import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';

import accessReducer from 'reducers/access/access.reducer';
import activityFeedReducer from 'reducers/activityFeedReducer.reducer';
import appointmentDepositReducer from 'reducers/appointmentDeposit.reducer';
import appointmentSidebarReducer from 'reducers/appointmentSidebar.reducer';
import balanceSheetReducer from 'reducers/balance.reducer';
import billingReducer from 'reducers/billing.reducer';
import clientProfileSidebarReducer from 'reducers/clientProfileSidebar.reducer';
import generalSidebarReducer from 'reducers/generalSidebar.reducer';
import procedureModalReducer from 'reducers/procedureModal.reducer';
import pushedSalonReducer from 'reducers/pushedSalon.reducer';
import requestStatusReducer from 'reducers/requestStatus.reducer';
import rolesReducer from 'reducers/roles.reducer';
import salonInfoReducer from 'reducers/salonInfo/salonInfo.reducer';
import salonListReducer from 'reducers/salonList.reducer';
import salonSetupReducer from 'reducers/salonSetup.reducer';
import customClientTagsReducer from 'reducers/tags/customClientTags.reducer';
import timeOffReducer from 'reducers/timeOff/timeOff.reducer';
import transactionCreateReducer from 'reducers/transaction/create.reducer';
import transactionEmailSend from 'reducers/transaction/email.reducer';
import uiReducer from 'reducers/ui.reducer';
import { AT_LOGOUT_SUCCESS, rcmCognitoReducer } from 'utils/cognito.util';
import { nowAsIso } from 'utils/date/now.util';

import bookingReducer from 'booking/reducer';
import cashupReducer from 'cashup/reducer';
import productReducer from 'checkout/product.reducer';
import checkoutReducer from 'checkout/reducer';
import clientCommunicationsReducer from 'clientCommunications/reducer';
import clientProfileReducer from 'clientProfile/reducer';
import currentSalonReducer from 'lib/reducers/currentSalonReducer';
import libReducer from 'lib/reducers/lib.reducer';
import mergeClientsReducer from 'mergeClients/reducer';
import notificationReducer from 'notification/reducer';
import servicesReducer from 'onboarding/services/reducer';
import stylistsReducer from 'onboarding/stylists/stylists.reducer';
import clientListReducer from 'reports/DownloadableReports/clients/reducer';
import reportsReducer from 'reports/reports.reducer';
import currentReducer from 'salon/current.reducer';
import currentStylistReducer from 'salon/currentStylist.reducer';
import salonProductReducer from 'salon/salonProduct.reducer';
import salonServicesReducer from 'salon/salonServices.reducer';
import stylistListReducer from 'salon/stylistList.reducer';
import userPermissionReducer from 'salon/userPermission.reducer';
import scheduleReducer from 'scheduler/schedule.reducer';
import noShowVisibilityReducer from 'settings/noshowvisibility/reducer';
import onlineBookingReducer from 'settings/online-booking/reducer';
import permissionsReducer from 'settings/permissions/reducer';
import productsReducer from 'settings/product-listing/reducer';
import stockManagementReducer from 'stocks/reducer';

// NOTE: just a reducer for testing the store and actions
const $test = (state, action) => (action?.type === '$test' ? { ...state, action, $now: nowAsIso() } : state ?? {});

const rootReducer = combineReducers({
  cognito: rcmCognitoReducer,
  form: reduxFormReducer, //
  //
  settings: combineReducers({
    onlineBooking: onlineBookingReducer,
    products: productsReducer,
    balanceSheet: balanceSheetReducer,
    permissions: permissionsReducer,
    noshowVisibility: noShowVisibilityReducer,
    clientList: clientListReducer,
    billing: billingReducer,
  }),
  onboarding: combineReducers({
    salonSetup: salonSetupReducer,
    roles: rolesReducer,
    services: servicesReducer,
    stylists: stylistsReducer,
  }), //
  //
  access: accessReducer,
  activity: activityFeedReducer,
  booking: bookingReducer,
  cashup: cashupReducer,
  currentSalon: currentSalonReducer,
  clientCommunications: clientCommunicationsReducer,
  clientProfile: clientProfileReducer,
  checkout: checkoutReducer,
  lib: libReducer,
  mergeClients: mergeClientsReducer,
  notification: notificationReducer,
  product: productReducer,
  pushedSalon: pushedSalonReducer,
  reports: reportsReducer,
  salon: combineReducers({
    stylistList: stylistListReducer,
    currentStylist: currentStylistReducer,
    product: salonProductReducer,
    services: salonServicesReducer,
    salonList: salonListReducer,
    current: currentReducer,
    userPermission: userPermissionReducer,
    customClientTags: customClientTagsReducer,
  }),
  salonInfo: salonInfoReducer,
  scheduler: scheduleReducer,
  sidebar: combineReducers({
    appointment: appointmentSidebarReducer,
    clientProfile: clientProfileSidebarReducer,
    general: generalSidebarReducer,
    procedureModal: procedureModalReducer,
    deposit: appointmentDepositReducer,
  }),
  stockManagement: stockManagementReducer,
  timeOff: timeOffReducer,
  transaction: combineReducers({
    create: transactionCreateReducer,
    emailSend: transactionEmailSend,
  }), //
  //
  requestStatus: requestStatusReducer,
  ui: uiReducer,
  $test,
});

// on logout, reset the entire state
const rootReducerWrap = (state, action) =>
  rootReducer(action?.type === AT_LOGOUT_SUCCESS ? { cognito: state?.cognito } : state, action);

export default rootReducerWrap;
